export const PLACEHOLDER_AVATAR_IMAGE = {
  id: 'WyJDb250cmFJbWFnZSIsNDQ0NDAzNF0=',
  uid: 'l0qbgdoqcyqfiutyaeri',
  url: '',
};
